import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "FiltroDeDados";
export const Listar = (filtroDeDados) =>
  RequestWebApi.get(`/${controller}/Listar`, {
    params: { ...filtroDeDados },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const filtrosDeDados = resultData;
      return { success, filtrosDeDados };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { filtrosDeDados: [] };
    });

export const Detalhes = (filtroDeDadosId) =>
  RequestWebApi.get(`/${controller}/Detalhes`, {
    params: { filtroDeDadosId: filtroDeDadosId },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const filtroDeDados = resultData;
      return { success, filtroDeDados };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors, filtroDeDados: {} };
    });

export const Incluir = (filtroDeDados) =>
  RequestWebApi.post(`/${controller}/Incluir`, filtroDeDados)
    .then(function (response) {
      const { resultData, success } = response.data;
      const filtroDeDadosId = resultData;
      return { success, filtroDeDadosId };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Atualizar = (filtroDeDados) =>
  RequestWebApi.put(`/${controller}/Atualizar`, filtroDeDados)
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Remover = (filtroDeDadosId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { filtroDeDadosId: filtroDeDadosId },
  })
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });
